import { LicenseInfo } from '@mui/x-license';

import webixInit from 'Lib/Webix/helpers/webixInit.js';

import initMainMenu from '../MainMenu/mainMenuController.js';
import sidemenuInit from '../Sidemenu/sidemenu.js';

import { router, initRouter } from './appRouter';
import uiBlock, { killWebix } from './config/blocks';
import setGlobals from './globals.js';
import container from './services/container';
import events from './utils/events';
import initApp from './utils/initApp';

import 'Application/assets/scss/datatable.original.scss';
import 'Application/assets/scss/styleTable.original.scss';
import 'Application/assets/scss/buttons.original.scss';
import 'Application/assets/scss/tabbar.original.scss';
import 'Application/assets/scss/accordion.orig.scss';
import 'Application/assets/scss/style.orig.scss';

setGlobals({ uiBlock, events, router });

function init() {
    webixInit();
    initRouter(events);
    sidemenuInit();
    initMainMenu(container);

    LicenseInfo.setLicenseKey('bac340734dd2c4178cd9d0b9b8ac6b37Tz0xMTQyMzEsRT0xNzgwODc2Nzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y');
}

initApp();

events.once('oldapp:loaded', init, false);
events.on('oldrouter:beforeRouting', killWebix, false);
